import PropTypes from 'prop-types';
import { ReactNode, useMemo } from 'react';

import { CssBaseline, StyledEngineProvider, ThemeOptions } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import componentsOverride from 'themes/components/index.ts';

import Palette from './palette';
import Typography from './typography';
import { useStore } from 'store/store';

type Props = {
  children: ReactNode;
};
export default function ThemeCustomization({ children }: Props) {
  const colorMode = useStore().colorMode;
  const theme = Palette(`${colorMode}`);

  const themeOptions: ThemeOptions = useMemo(
    () => ({
      ...theme,
      typography: Typography,
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1536,
        },
      },
      direction: 'ltr',
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    }),
    [theme],
  );

  const themes = createTheme(themeOptions);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  themes.components = componentsOverride(themes);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeCustomization.propTypes = {
  children: PropTypes.node,
};
